import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { COLORS } from '~/data/ui/colors';
import { setCookie } from '~/utils/cookieStorageHandlers';

interface GlowWrapperProps {
  children: React.ReactNode;
  show?: boolean;
}

const GlowWrapper: React.FC<GlowWrapperProps> = ({ children, show = true }) => {
  const [isGlowing, setIsGlowing] = useState(show);

  useEffect(() => {
    setIsGlowing(show);
  }, [show]);
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        setCookie('hasVisitedUsedCarListingsPage', true, 1000);
        setIsGlowing(false);
      }, 5000);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [show]);

  return (
    <Box
      sx={{
        zIndex: '10',
        display: 'inline-block',
        position: 'relative',
        padding: '4px',
        borderRadius: '50%',
        animation: isGlowing
          ? 'glowAnimation 1.5s infinite ease-in-out'
          : 'none',
        '@keyframes glowAnimation': {
          '0%': {
            boxShadow: `0 0 5px ${COLORS.primary.main}`,
          },
          '50%': {
            boxShadow: `0 0 25px ${COLORS.primary.main}`,
          },
          '100%': {
            boxShadow: `0 0 5px ${COLORS.primary.main}`,
          },
        },
      }}
    >
      {children}
    </Box>
  );
};

export default GlowWrapper;
